"use client";
import { jsx } from "react/jsx-runtime";
import { Dialog } from "@base-ui/react/dialog";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { dialogVariants } from "./Dialog.variants.js";
import { useDialogMode } from "./DialogContext.js";
const { description: description } = dialogVariants();
const DialogDescription_DialogDescription = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    const mode = useDialogMode();
    const classes = cn(description(), className, slots?.description);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Description, {
        ref: ref,
        className: classes,
        ...props
    });
    return /*#__PURE__*/ jsx(Dialog.Description, {
        ref: ref,
        className: classes,
        ...props
    });
});
export { DialogDescription_DialogDescription as DialogDescription };
